import logo from './assets/images/logo.svg';
import logo_apple from './assets/images/logo_apple.svg';
import logo_android from './assets/images/logo_android.svg';
import logo_eu from './assets/images/logo_eu.png';
import burger_menu from './assets/images/burger_menu.svg';
import screen_main_header from './assets/images/screen_main_header.png';
import icon_player from './assets/images/icon_play.svg';
import icon_activity from './assets/images/icon_activity.svg';
import icon_chart from './assets/images/icon_chart.svg';
import icon_euro from './assets/images/icon_euro.svg';
import icon_percent from './assets/images/icon_percent.svg';
import icon_book from './assets/images/icon_book.svg';
import icon_ai from './assets/images/icon_ai.svg';
import icon_world from './assets/images/icon_world.svg';
import icon_trending from './assets/images/icon_trending.svg';
import icon_users from './assets/images/icon_users.svg';
import icon_wallet from './assets/images/icon_wallet.svg';
import icon_doodle from './assets/images/icon_doodle.png';
import icon_chevron from './assets/images/icon_chevron.svg';
import module_1 from './assets/images/module_1.png';
import module_2 from './assets/images/module_2.png';
import module_3 from './assets/images/module_3.png';
import module_4 from './assets/images/module_4.png';
import background_circle from './assets/images/background_cercle.svg';
import background_doodle from './assets/images/background_doodle.png';
import image_eu_regulation_1 from './assets/images/image_eu_regulation_1.png';
import image_doodle_1 from './assets/images/image_doodle_1.png';
import image_doodle_2 from './assets/images/image_doodle_2.png';
import image_doodle_3 from './assets/images/image_doodle_3.png';
import image_eu_regulation_2 from './assets/images/image_eu_regulation_2.png';
import image_home_future_1 from './assets/images/image_home_future_1.png';
import image_home_future_2 from './assets/images/image_home_future_2.png';
import image_home_future_3 from './assets/images/image_home_future_3.png';
import image_home_future_4 from './assets/images/image_home_future_4.png';
import image_home_future_5 from './assets/images/image_home_future_5.png';
import image_home_future_6 from './assets/images/image_home_future_6.png';
import image_home_future_7 from './assets/images/image_home_future_7.png';
import image_stripe from './assets/images/image_stripe.png'

const IMAGES_PATH = {
  LOGO: logo,
  BURGER_MENU: burger_menu,
  SCREEN_MAIN_HEADER: screen_main_header,
  LOGO_APPLE: logo_apple,
  LOGO_ANDROID: logo_android,
  LOGO_EU: logo_eu,
  ICON_PLAYER: icon_player,
  ICON_CHART: icon_chart,
  ICON_EURO: icon_euro,
  ICON_ACTIVITY: icon_activity,
  ICON_PERCENT: icon_percent,
  ICON_WORLD: icon_world,
  ICON_BOOK: icon_book,
  ICON_AI: icon_ai,
  ICON_TRENDING: icon_trending,
  ICON_WALLET: icon_wallet,
  ICON_USERS: icon_users,
  ICON_DOODLE: icon_doodle,
  ICON_CHEVRON: icon_chevron,
  MODULE_1: module_1,
  MODULE_2: module_2,
  MODULE_3: module_3,
  MODULE_4: module_4,
  BACKGROUND_CIRCLE: background_circle,
  BACKGROUND_DOODLE: background_doodle,
  IMAGE_DOODLE_1: image_doodle_1,
  IMAGE_DOODLE_2: image_doodle_2,
  IMAGE_DOODLE_3: image_doodle_3,
  IMAGE_HOME_FUTURE_1: image_home_future_1,
  IMAGE_EU_REGULATION_1: image_eu_regulation_1,
  IMAGE_EU_REGULATION_2: image_eu_regulation_2,
  IMAGE_HOME_FUTURE_2: image_home_future_2,
  IMAGE_HOME_FUTURE_3: image_home_future_3,
  IMAGE_HOME_FUTURE_4: image_home_future_4,
  IMAGE_HOME_FUTURE_5: image_home_future_5,
  IMAGE_HOME_FUTURE_6: image_home_future_6,
  IMAGE_HOME_FUTURE_7: image_home_future_7,
  IMAGE_STRIPE: image_stripe,
};

export default IMAGES_PATH;
